import axios from 'axios'
const { VUE_APP_API_URL } = process.env

const fetchJet2Info = async (name) => {
  try {
    const res = await axios
      .post(`${VUE_APP_API_URL}/api/jet2`, { "name": name })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}


export {
  fetchJet2Info
}
